'use server';

import type { UserInfoResponse } from '@/app/_types/user-info';

/**
 * Fetches user information from the gateway API
 * @param token - Optional authorization token. If not provided, uses credentials from cookies
 * @returns UserInfoResponse with user data or error message
 */
export async function fetchUserInfoAction(
  token?: string,
): Promise<UserInfoResponse> {
  try {
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };

    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL || ''}/gateway/me`,
      {
        method: 'GET',
        headers,
        credentials: 'include',
      },
    );

    if (!response.ok)
      return {
        success: false,
        message: `Failed to fetch user info: ${response.statusText}`,
      };

    const userData = await response.json();

    return {
      success: true,
      data: userData,
    };
  } catch {
    return {
      success: false,
      message: 'Failed to fetch user info.',
    };
  }
}
